import { createElement, lazy } from 'react';

import { urls } from '@treneo/shared/constants';
import type { RouteModule } from '@treneo/shared/router';

const AdminCachePage = lazy(() =>
  import('./cache/admin-cache-page').then(module => ({ default: module.AdminCachePage }))
);
const AdminDefaultPage = lazy(() =>
  import('./admin-default-page').then(module => ({ default: module.AdminDefaultPage }))
);
const AdminHealthPage = lazy(() =>
  import('./health/admin-health-page').then(module => ({ default: module.AdminHealthPage }))
);
const AdminPermissionsPage = lazy(() =>
  import('./permissions/admin-permissions-page').then(module => ({
    default: module.AdminPermissionsPage
  }))
);
const AdminPermissionDetailPage = lazy(() =>
  import('./permissions/admin-permission-detail-page').then(module => ({
    default: module.AdminPermissionDetailPage
  }))
);
const AdminSynchronizationPage = lazy(() =>
  import('./synchronization/admin-synchronization-page').then(module => ({
    default: module.AdminSynchronizationPage
  }))
);
const AdminUserDetailPage = lazy(() =>
  import('./users/admin-user-detail-page').then(module => ({
    default: module.AdminUserDetailPage
  }))
);
const AdminUsersPage = lazy(() =>
  import('./users/admin-users-page').then(module => ({ default: module.AdminUsersPage }))
);
const AdminLoginActivityPage = lazy(() =>
  import('./login-activity/admin-login-activity-page').then(module => ({
    default: module.AdminLoginActivityPage
  }))
);

export const getAdminRouteModule = (): RouteModule => ({
  id: 'admin',
  routes: [
    { path: urls.adminPanel, element: createElement(AdminDefaultPage) },
    { path: urls.adminHealthPage, element: createElement(AdminHealthPage) },
    { path: urls.adminUsersPage, element: createElement(AdminUsersPage) },
    {
      path: urls.routePaths.adminUserDetail,
      element: createElement(AdminUserDetailPage)
    },
    { path: urls.adminPermissionsPage, element: createElement(AdminPermissionsPage) },
    {
      path: urls.routePaths.adminPermissionDetail,
      element: createElement(AdminPermissionDetailPage)
    },
    { path: urls.adminCachePage, element: createElement(AdminCachePage) },
    {
      path: urls.adminSynchronizationPage,
      element: createElement(AdminSynchronizationPage)
    },
    {
      path: urls.adminLoginActivityPage,
      element: createElement(AdminLoginActivityPage)
    }
    // invitations are owned by organizations module; route is now handled there
  ]
});
